import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eStudentLogActionTypeIds, IStudentLogActionTypes } from "../../action-types/y-te/IStudentLogActionTypes";
import { IStudentLogPageStateModel } from "../../page-state-model/y-te/IStudentLogPageState";

const initialState: IStudentLogPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	student_logs: [],
	student_log_editing: undefined,
	student_log_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_loading_detail: false
}

export const studentLogReducer = (state: IStudentLogPageStateModel = initialState, action: IStudentLogActionTypes): IStudentLogPageStateModel => {
	switch (action.type) {
		case eStudentLogActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eStudentLogActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				student_logs: action.payload
			}
		case eStudentLogActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				student_logs: []
			}
		case eStudentLogActionTypeIds.LOAD_DETAIL_START:
			return {
				...state,
				is_loading_detail: true
			}
		case eStudentLogActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				is_loading_detail: false,
				student_log_editing: action.payload
			}
		case eStudentLogActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				is_loading_detail: false
			}
		case eStudentLogActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				student_log_editing: action.payload
			}
		case eStudentLogActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				student_log_editing: undefined
			}
		case eStudentLogActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				student_log_selected_ids: action.payload
			}
		case eStudentLogActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eStudentLogActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eStudentLogActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eStudentLogActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				student_log_editing: undefined
			}
		case eStudentLogActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eStudentLogActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eStudentLogActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				student_log_editing: undefined,
				student_log_selected_ids: []
			}
		case eStudentLogActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
